module.exports = __webpack_public_path__ + "static/media/polymedia-peter-van-der-meer-black.b31f4238.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/StartPages/polymedia-peter-van-der-meer-black.png
// module id = 200
// module chunks = 0